import React, { useState, useEffect } from "react";
import styles from "./SelectNewItem.module.css";
import { exchangeItemSelectConfig } from "./exchangeItemSelectConfig";

const SelectNewItem = ( { businessKey, currentProductBeingExchanged, exchangeProductData, newItemsSelectedOptions, setNewItemsSelectedOptions } ) => {
	const [showSelectProductBox, setShowSelectProductBox] = useState(false);
	const [selectedOptions, setSelectedOptions] = useState(newItemsSelectedOptions.find(obj => obj.unique_id === currentProductBeingExchanged.unique_id));
	//const productTitle = selectedOptions.selected_product || currentProductBeingExchanged.product_title;
	const productSku = selectedOptions.product_sku || currentProductBeingExchanged.product_sku;
	//const product = exchangeProductData.find(p => p.product_title === productTitle);
	const product = exchangeProductData.find(p => p.shopify_variants.some(v => v.sku === productSku));
	const [variantOptions, setVariantOptions] = useState(product.shopify_options);
	const companyConfig = exchangeItemSelectConfig[businessKey];

	//update state of selectedOptions
	useEffect(() => {
		const match = newItemsSelectedOptions.find(obj => obj.unique_id === currentProductBeingExchanged.unique_id);
	  	setSelectedOptions(match);
	}, [currentProductBeingExchanged]);

	// Merge selectedOptions into global state (newItemsSelectedOptions) while preserving all keys from both objects
	useEffect(() => {
		setNewItemsSelectedOptions(prev => {
			const index = prev.findIndex(item => item.unique_id === selectedOptions.unique_id);
			if (index !== -1) {
				const existingItem = prev[index];
				const merged = { ...selectedOptions, ...existingItem, ...selectedOptions }; // double spread ensures selectedOptions values win, but preserves all keys
				const updated = [...prev];
				updated[index] = merged;
				return updated;
			} else { return [...prev, selectedOptions]; } // Add new item 
		});
	}, [selectedOptions]);

	//default Gender to "Men"
	useEffect(() => {
		const hasGender = variantOptions?.some(o => o.name === "Gender");
	  	if (!hasGender) return;
	  	setSelectedOptions(prev => {
	    	if (prev?.Gender) return prev;
	    	return { ...prev, Gender: "Men" };
	  	});
	}, [variantOptions]);

	//helper to evaluate rules from config
	const applyVariantRules = ({ optionName, values, selectedOptions, rules }) => {
		let filtered = [...values];
	  	if (!rules) return filtered;
	  	rules.forEach(rule => {
	    	const matchesCondition = Object.entries(rule.when).every(([key, val]) => selectedOptions?.[key] === val);
	    	if (!matchesCondition) return;
	    	const effect = rule.then?.[optionName];
	    	if (!effect) return;
	    	if (effect.disallow) { filtered = filtered.filter(v => !effect.disallow.includes(v)); }
	    	if (effect.allow) { filtered = filtered.filter(v => effect.allow.includes(v)); }
	  	});
	  	return filtered;
	};

	const showProductBox = () => { showSelectProductBox ? setShowSelectProductBox(false) : setShowSelectProductBox(true); }
	
	//select a given variant
	const toggleValue = (key_name, option_selected) => {
		setSelectedOptions(prev => {
			const current = prev[key_name] || null;
			if (key_name === "Gender") { 
				//clear the size field
				return { ...prev, Gender: option_selected, Size: null }; 
			} // Gender should never be null — only toggle Men/Women. This is to prevent selecting a size that isn't available
			return {...prev, [key_name]: current === option_selected ? null : option_selected};
		});
	};

	// const handleProductSelect = (productTitle, productImage, productId) => {
	// 	const product = exchangeProductData.find(p => p.product_title === productTitle);
	// 	setVariantOptions(product.shopify_options);
	// 	setSelectedOptions(prev => ({...prev, selected_product: productTitle, selected_product_image: productImage, product_id: productId}));
	// 	setShowSelectProductBox(false);
	// };

	const handleProductSelect = (productTitle, productImage, productId, productOptions) => {
		setVariantOptions(productOptions);
		setSelectedOptions(prev => ({...prev, selected_product: productTitle, selected_product_image: productImage, product_id: productId}));
		setShowSelectProductBox(false);
	};

	return (
		<div className={`${styles.select_new_item_container} fade_in`}>
			<div className={styles.select_new_product_wrapper}>
				<p className={styles.product_title}>Product</p>
				<div className={styles.product_title_box} onClick={() => { showProductBox(); }}>
					<div className={styles.dropdown_product_title_wrapper}>
						<p className={styles.dropdown_product_title}>{newItemsSelectedOptions.find(item => item.unique_id === currentProductBeingExchanged.unique_id)?.selected_product || "Select a new item"}</p>
					</div>
					<img className={styles.product_dropdown_icon} src={`${showSelectProductBox ? `${process.env.PUBLIC_URL}/images/dropdown_arrow_back.png` : `${process.env.PUBLIC_URL}/images/dropdown_arrow.png`}`} />
				</div>
				{showSelectProductBox && (
					// <div className={styles.select_product_box}>
					// 	{exchangeProductData
					// 		.filter(product => (parseFloat(product.product_cost) === parseFloat(currentProductBeingExchanged.product_cost)) || product.product_title === currentProductBeingExchanged.product_title) /*only show product options for exchanges that are same price for now */
					// 		.map((product, index) => (
					// 			<div key={index} className={styles.product_option_wrapper} onClick={() => handleProductSelect(product.product_title, product.product_image, product.product_id)}>
					// 				<div className={styles.product_title_option_wrapper}>
					// 					<p className={styles.product_title_option}>{product.product_title}</p>
					// 				</div>
					// 				<img src={product.product_image} alt={product.product_title} className={styles.product_image_option} />
					// 			</div>
					// 	))}
					// </div>
					<div className={styles.select_product_box}>
						{exchangeProductData
							.filter(product => (parseFloat(product.product_cost) === parseFloat(currentProductBeingExchanged.product_cost)) || product.shopify_variants.some(v => v.sku === currentProductBeingExchanged.product_sku)) 
							.map((product, index) => (
								<div key={index} className={styles.product_option_wrapper} onClick={() => handleProductSelect(product.product_title, product.product_image, product.product_id, product.shopify_options)}>
									<div className={styles.product_title_option_wrapper}>
										<p className={styles.product_title_option}>{product.product_title}</p>
									</div>
									<img src={product.product_image} alt={product.product_title} className={styles.product_image_option} />
								</div>
						))}
					</div>
				)}
			</div>
			{variantOptions?.map((option, index) => {
				if (option.values.length <= 1) return null;
				const globalMatch = newItemsSelectedOptions.find(item => item.unique_id === currentProductBeingExchanged.unique_id);
				const filteredValues = applyVariantRules({optionName: option.name, values: option.values, selectedOptions: globalMatch, rules: exchangeItemSelectConfig?.[businessKey]?.variantRules});
  				if (filteredValues.length === 0) return null;
				return (
					<div key={index} className={styles.variant_option_wrapper}>
						<p className={styles.variant_option_name}>{option.name}</p>
						<div className={styles.variant_value_box}>
							{filteredValues.map((value, vIndex) => {
								const isSelected = globalMatch?.[option.name] === value;
								return (
									<div key={vIndex} className={`${styles.variant_value_pill} ${isSelected ? styles.selected : ""}`} onClick={() => toggleValue(option.name, value)} >
										{value}
									</div>
								);
							})}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default SelectNewItem;